import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const PageTitle = ({ title, subtitle }) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        //pt: 2,
        //pb: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: theme.palette.text.primary,
          //mb: subtitle ? 0.5 : 0,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default PageTitle; 